var _module_exports = "<span>You are set as \"Available\".</span>\n";;
var path = 'views/flashes/avail_persistant.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;